import { render, staticRenderFns } from "./AdminUtils.vue?vue&type=template&id=367ed16e&scoped=true&"
import script from "./AdminUtils.vue?vue&type=script&lang=ts&"
export * from "./AdminUtils.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ed16e",
  null
  
)

export default component.exports